/* Alira The Label — Shipping Protection auto-add
   The cart-drawer upsell toggle is pre-selected (data-selected="true") but the
   theme only adds the product when the toggle is clicked. This script keeps the
   cart in sync with the toggle:
   - theme adds a product          -> protection is added FIRST, then the theme's
                                       add runs, so the drawer renders with the
                                       correct total straight away
   - cart has items, no protection -> add protection (fallback, unless opted out)
   - protection is the only line   -> remove it
   - customer switches toggle off  -> remember for this session, don't re-add */
(function () {
  'use strict';
  var SP_VARIANT = 58257040998781;
  var OPT_KEY = 'alira_sp_opt_out';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var busy = false, autoAdds = 0, timer = null, hasSPKnown = null;
  var origFetch = window.fetch;

  function optedOut() { try { return sessionStorage.getItem(OPT_KEY) === '1'; } catch (e) { return false; } }
  function setOptOut(v) { try { v ? sessionStorage.setItem(OPT_KEY, '1') : sessionStorage.removeItem(OPT_KEY); } catch (e) {} }

  function getCart() {
    return origFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function hasSP(cart) { return cart.items.some(function (i) { return i.variant_id === SP_VARIANT; }); }
  function realItems(cart) { return cart.items.filter(function (i) { return i.variant_id !== SP_VARIANT; }).length; }

  function postCart(path, payload) {
    return origFetch(path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }
  function addSPRaw() { autoAdds++; hasSPKnown = true; return postCart('/cart/add.js', { items: [{ id: SP_VARIANT, quantity: 1 }] }); }
  function removeSPRaw() { hasSPKnown = false; return postCart('/cart/change.js', { id: String(SP_VARIANT), quantity: 0 }); }

  // Make sure protection is in the cart BEFORE the theme's own add request runs
  function ensureSP() {
    if (optedOut() || autoAdds >= 3 || hasSPKnown === true) return Promise.resolve();
    if (hasSPKnown === false) return addSPRaw().catch(function () {});
    return getCart().then(function (cart) {
      hasSPKnown = hasSP(cart);
      if (!hasSPKnown) return addSPRaw();
    }).catch(function () {});
  }

  function renderSections() {
    // Same section-render flow the theme (Dawn-based) uses after cart changes
    return origFetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var tmp = document.createElement('div');
        if (s['cart-drawer']) {
          tmp.innerHTML = s['cart-drawer'];
          var fresh = tmp.querySelector('#CartDrawer'), cur = document.getElementById('CartDrawer');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          var drawer = document.querySelector('cart-drawer'), freshDrawer = tmp.querySelector('cart-drawer');
          if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        }
        if (s['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = s['cart-icon-bubble'];
        }
      }).catch(function () {});
  }

  // Fallback sync (page load, or anything the interception missed)
  function sync() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var sp = hasSP(cart), real = realItems(cart);
      hasSPKnown = sp;
      if (sp && real === 0) return removeSPRaw().then(renderSections);
      if (!sp && real > 0 && !optedOut() && autoAdds < 3) return addSPRaw().then(renderSections);
    }).catch(function () {}).then(function () { busy = false; });
  }
  function scheduleSync(ms) { clearTimeout(timer); timer = setTimeout(sync, ms || 300); }

  // Remember the customer's choice when they use the toggle themselves
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('cart-drawer-upsell[data-handle="shipping-protection"] .upsell-toggle-btn');
    if (!btn) return;
    var before = hasSPKnown;
    setTimeout(function () {
      getCart().then(function (cart) {
        var now = hasSP(cart);
        if (before === true && !now) setOptOut(true);
        if (now) setOptOut(false);
        hasSPKnown = now;
      }).catch(function () {});
    }, 1500);
  }, true);

  // Intercept the theme's cart requests
  window.fetch = function (input, init) {
    var self = this, args = arguments;
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!CART_RE.test(url)) return origFetch.apply(self, args);
    var isAdd = /\/cart\/add/.test(url);
    var run = function () {
      var p = origFetch.apply(self, args);
      p.then(function () { scheduleSync(isAdd ? 400 : 300); }).catch(function () {});
      return p;
    };
    return isAdd ? ensureSP().then(run, run) : run();
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', function () { scheduleSync(300); });
    return origOpen.apply(this, arguments);
  };

  // Learn the cart state early so ensureSP() rarely needs an extra round trip
  getCart().then(function (cart) { hasSPKnown = hasSP(cart); }).catch(function () {});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scheduleSync(600); });
  else scheduleSync(600);
})();
